import { middleofficeRequest } from '../../../axios'

export default class ApiGetBudgetOverview {
  async getFiscalYears(coproId, endPoint) {
    try {
      const res = await middleofficeRequest.get(
        `${endPoint}/condos/${coproId}/fiscal-years`
      )
      return res.data
    } catch (error) {
      return []
    }
  }

  async getBudgets(coproId, fiscalYearId, endPoint) {
    try {
      const res = await middleofficeRequest.get(
        `${endPoint}/condos/${coproId}/fiscal-years/${fiscalYearId}/budgets`
      )
      return res.data
    } catch (error) {
      return []
    }
  }
}
